const store = Vue.reactive({
  state: {
    cartState: [],
    cart: null,
    location: null,
  },
  async getGeolocation() {
    const cachedLocation = sessionStorage.getItem('ul');
    if (cachedLocation) {
      this.state.location = cachedLocation;
      return;
    }
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();
    this.state.location = data.country;
    sessionStorage.setItem('ul', data.country);
  },
  async getCart() {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart");
    const cart = await response.json();
    this.state.cart = cart;
  },
  async addToCart(formData) {
    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(async () => {
        await this.getCart();
        return true;
      })
      .catch((error) => {
        console.error("Error:", error);
        return false;
      });
  },
  async clearCart() {
    return fetch(window.Shopify.routes.root + "cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async () => {
        await this.getCart();
        // Find and close any open quick-buy panel
        const openQuickBuy = document.querySelector(".quick-buy:not(.hidden)");
        if (openQuickBuy) {
          const productId = openQuickBuy.id.split("-")[3];
          window.toggleQuickBuy(productId);
        }
        return true;
      })
      .catch((error) => {
        console.error("Error:", error);
        return false;
      });
  },
  async changeItem(itemID, itemKey, quantity) {
    return fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity,
      }),
    })
      .then(async (data) => {
        if (quantity > 0) {
          const currentItems = store.state.cart.items;
          const result = await data.json();
          // Find the item in currentItems and update it with new data
          const updatedItems = currentItems.map((item, index) => {
            if (item.id === itemID) {
              const newItem = result.items[index];
              if (newItem) {
                // Keep the current quantity but update everything else
                return { ...newItem, quantity: item.quantity };
              }
            }
            return item;
          });
          store.state.cart = {
            ...store.state.cart,
            original_total_price: result.original_total_price,
            total_price: result.total_price,
            total_discounts: result.total_discounts,
            total_weight: result.total_weight,
            items_subtotal_price: result.items_subtotal_price,
            item_count: result.item_count,
            items: updatedItems
          };
        } else await this.getCart();  
        return true;
      })
      .catch((error) => {
        console.error("Error:", error);
        return false;
      });
  },
  async changeSellingPlan(itemID, sellingPlanID, quantity) {
    return fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: itemID,
        selling_plan: sellingPlanID,
        quantity: quantity,
      }),
    })
      .then(async () => {
        await this.getCart();
        return true;
      })
      .catch((error) => {
        console.error("Error:", error);
        return false;
      });
  },
  isUK() {
    return this.state.location === "GB" || !this.state.location;
  }
});

const miniCartState = Vue.reactive({
  hidden: true,
});

const toggleMiniCart = {
  openCart() {
    miniCartState.hidden = !miniCartState.hidden;
    menuState.hidden = true;
  },
};

const menuState = Vue.reactive({
  hidden: true,
});

const toggleMenu = {
  openMenu() {
    menuState.hidden = !menuState.hidden;
    miniCartState.hidden = true;
  },
};

const toggleClose = {
  closeAll() {
    miniCartState.hidden = true;
    menuState.hidden = true;
  },
};

const formatCurrency = (currency, amount, decimals = 2) => {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(amount / 100);
};

store.getCart();
store.getGeolocation();

window.removeForceNavbarWhite = function () {
  const navbar = document.getElementById("mega-menu-wrapper");
  if (
    navbar &&
    navbar.classList.contains("force-navbar-white") &&
    window.scrollY === 0
  ) {
    navbar.classList.remove("force-navbar-white");
  }
};

window.addForceNavbarWhite = function () {
  const navbar = document.getElementById("mega-menu-wrapper");
  navbar.classList.add("force-navbar-white");
};

const modalState = Vue.reactive({
  openModals: new Set(),
  sharedFadeout: null,
  init() {
    this.sharedFadeout = document.getElementById("shared-fadeout");
    if (this.sharedFadeout) {
      this.sharedFadeout.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeLastModal();
      });
    }
  },
  lockScroll() {
    if (this.openModals.size > 0) {
      document.documentElement.classList.add("overflow-hidden");
    }
  },
  unlockScroll() {
    if (this.openModals.size === 0) {
      document.documentElement.classList.remove("overflow-hidden");
    }
  },
  addModal(modalId) {
    this.openModals.add(modalId);
    this.lockScroll();
    // Show shared fadeout if it's not search modal
    if (modalId !== 'search' && this.sharedFadeout) {
      this.sharedFadeout.classList.remove("hidden");
      this.sharedFadeout.classList.remove("opacity-0");
      this.sharedFadeout.classList.add("opacity-100");
      this.sharedFadeout.classList.remove("pointer-events-none");
      this.sharedFadeout.classList.add("pointer-events-auto");
    }
  },
  removeModal(modalId) {
    this.openModals.delete(modalId);
    this.unlockScroll();
    
    // Only hide fadeout if there are no non-search modals left
    const hasNonSearchModals = Array.from(this.openModals).some(id => id !== 'search');
    
    if (modalId !== 'search' && this.sharedFadeout && !hasNonSearchModals) {
      this.sharedFadeout.classList.add("opacity-0");
      this.sharedFadeout.classList.remove("opacity-100");
      this.sharedFadeout.classList.add("pointer-events-none");
      this.sharedFadeout.classList.remove("pointer-events-auto");
      
      // Wait for transition to complete before hiding
      setTimeout(() => {
        const stillHasNonSearchModals = Array.from(this.openModals).some(id => id !== 'search');
        if (!stillHasNonSearchModals) {
          this.sharedFadeout.classList.add("hidden");
        }
      }, 300);
    }
  },
  closeLastModal() {
    if (this.openModals.size > 0) {
      const lastModal = Array.from(this.openModals).pop();
      if (lastModal === 'cart') {
        toggleCart();
      } else if (lastModal === 'quick-buy') {
        // Find the last opened quick-buy and close it
        const openQuickBuy = document.querySelector(".quick-buy:not(.hidden)");
        if (openQuickBuy) {
          const productId = openQuickBuy.id.split("-")[2];
          toggleQuickBuy(productId);
        }
      } else if (lastModal === 'filters') {
        toggleFilters();
      } else if (lastModal === 'nutritional') {
        toggleNutritional();
      } else if (lastModal === 'search') {
        toggleSearch();
      }
    }
  }
});

// Initialize modalState
document.addEventListener('DOMContentLoaded', () => {
  modalState.init();
});

function toggleQuickBuy(productId) {
  let quickBuy = null;
  if (!productId) {
    const openQuickBuy = document.querySelector(".quick-buy:not(.hidden)");
    if (openQuickBuy) {
      const prodId = openQuickBuy.id.split("-")[2];
      toggleQuickBuy(prodId);
    }
  }
  else quickBuy = document.getElementById(`quick-buy-${productId}`);


  const panel = quickBuy.querySelector(`#panel-${productId}`);
  if (!panel) return;

  if (quickBuy.classList.contains("hidden")) {
    // Opening
    quickBuy.classList.remove("hidden");
    modalState.addModal('quick-buy');
    // Force a reflow
    panel.offsetHeight;
    panel.classList.remove("translate-x-full");

    // Wait for the panel to be fully visible and have proper dimensions
    setTimeout(() => {
      const glideElement = quickBuy.querySelector('.glide');
      if (glideElement && typeof Glide !== 'undefined' && !glideElement.hasAttribute('data-glide-initialized')) {
        // Ensure the glide element has proper dimensions
        glideElement.style.width = '100%';
        glideElement.style.height = 'auto';
        
        new Glide(glideElement, {
          type: 'carousel', 
          startAt: 0,
          perView: 1,
          gap: 0
        }).mount();
        glideElement.setAttribute('data-glide-initialized', 'true');
      } else if (!glideElement || typeof Glide === 'undefined') {
        console.warn('Glide initialization failed', {
          element: glideElement,
          Glide: typeof Glide
        });
      }
    }, 300);
  } else {
    // Closing
    panel.classList.add("translate-x-full");
    panel.addEventListener(
      "transitionend",
      () => {
        if (panel.classList.contains("translate-x-full")) {
          quickBuy.classList.add("hidden");
          modalState.removeModal('quick-buy');
        }
      },
      { once: true }
    );
  }
}

function toggleModal(type, content) {
  const modalId = type === 'search' ? 'search' : 
                 type === 'filters' ? 'filters' : 
                 type === 'nutritional' ? 'nutritional-modal' :
                 `${type}-drawer`;
  const fadeoutId = type === 'search' ? 'search-fadeout' : 'shared-fadeout';
  
  const modal = document.getElementById(modalId);
  const fadeout = document.getElementById(fadeoutId);
  
  if (!modal || (type === 'search' && !fadeout)) {
    console.error(`${type} modal not found. Make sure the ${type}-modal.liquid snippet is included in the page.`);
    return;
  }

  if (modal.classList.contains('hidden')) {
    // Opening
    if (content) {
      const contentDiv = document.getElementById(`${type}-modal-content`);
      if (contentDiv) contentDiv.innerHTML = content;
    }
    modal.classList.remove('hidden');
    if (fadeout) fadeout.classList.remove('hidden');
    modalState.addModal(type);
    // Force a reflow
    modal.offsetHeight;
    modal.classList.remove('translate-x-full');
    
    if (type === 'search') {
      window.addForceNavbarWhite();
    }
  } else {
    // Closing
    modal.classList.add('translate-x-full');
    
    // Handle search fadeout separately
    if (type === 'search' && fadeout) {
      fadeout.classList.add('hidden');
    }

    // Wait for the transition to complete before hiding
    modal.addEventListener(
      "transitionend",
      () => {
        if (modal.classList.contains("translate-x-full")) {
          modal.classList.add("hidden");
          modalState.removeModal(type);
          if (type === 'search') {
            window.removeForceNavbarWhite();
          }
        }
      },
      { once: true }
    );
  }
}

function toggleCart() {
  toggleModal('cart');
}

function toggleFilters() {
  const modal = document.getElementById('filters');
  
  // If opening filters and seo.hidden filter is not present, add it without reload
  if (modal && modal.classList.contains('hidden')) {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('filter.p.m.seo.hidden')) {
      urlParams.set('filter.p.m.seo.hidden', '0');
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
      
      // Update URL without reload
      window.history.replaceState({}, '', newUrl);
      
      // Fetch and update the collection content
      fetch(`${newUrl}&section_id=main-collection-product-grid`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Update the main collection content
          const currentCollection = document.querySelector('[data-section-type="collection"]') || 
                                   document.querySelector('#main-collection-product-grid') ||
                                   document.querySelector('.collection-grid');
          const newCollection = doc.querySelector('[data-section-type="collection"]') || 
                               doc.querySelector('#main-collection-product-grid') ||
                               doc.querySelector('.collection-grid');
          
          if (currentCollection && newCollection) {
            currentCollection.innerHTML = newCollection.innerHTML;
          }
          
          // Update filters content if needed
          const currentFilters = document.getElementById('filters');
          const newFilters = doc.getElementById('filters');
          if (currentFilters && newFilters) {
            currentFilters.innerHTML = newFilters.innerHTML;
          }
          
          // Re-initialize filter event listeners
          if (window.initializeFilterListeners) {
            window.initializeFilterListeners();
          }
        })
        .catch(error => {
          console.error('Error updating filters:', error);
          // Fallback to reload if AJAX fails
          window.location.href = newUrl;
        });
    }
  }
  
  toggleModal('filters');
}

function toggleSearch() {
  toggleModal('search');
}

function toggleNutritional(content) {
  toggleModal('nutritional', content);
}

window.toggleCart = toggleCart;
window.toggleFilters = toggleFilters;
window.toggleSearch = toggleSearch;
window.toggleQuickBuy = toggleQuickBuy;
window.toggleNutritional = toggleNutritional;

// Listen for Shopify cart updates
document.addEventListener("cart:refresh", async function (event) {
  console.log("cart:refresh", event);
  await store.getCart();
});
